module.exports = __webpack_public_path__ + "static/media/GT02_GT_Accommodation-Types.28519608.csv";